/* eslint-disable max-lines */
import React from "react";

export const categories = [
  {
    name: "物件について",
    slug: "asset",
  },
  {
    name: "お申込み",
    slug: "contract",
  },
  {
    name: "ご利用中",
    slug: "member",
  },
  {
    name: "その他",
    slug: "etc",
  },
];

export function getFaqs() {
  return [
    {
      category: "asset",
      key: "key1",
      title: "搬入・搬出はいつでもできるの？",
      content:
        '<div>コンテナタイプ（屋外型）<br>基本的に荷物の出し入れは24時間自由です。<br>トランクタイプ（屋内型）<br>基本的に荷物の出し入れは24時間自由ですが、時間制限がある物件もございます。<br>また、搬入・搬出の手段でお困りの方には<a onclick="return toInner(event, this)" href="/service/">便利な代行サービス</a>等もございます。</div>',
    },
    {
      category: "asset",
      key: "key2",
      title: "コンテナ（屋外型）の2階の利用方法は？",
      content:
        "<div>タラップ（移動式階段）を各現場にご用意しております。<br>そちらをご利用ください。</div>",
    },
    {
      category: "asset",
      key: "key3",
      title: "収納してはいけないもの（禁止収納物）は？",
      content:
        '<div>主に動植物、危険物、異臭・悪臭のする物品、<br>水分や高温を発する物品、貴重品、産業廃棄物、塗料等<br>弊社で禁止物として指定している物品はご遠慮いただいております。<br>詳しくは<a onclick="return toInner(event, this)" href="/agreement/">約款</a>をご確認ください。</div>',
    },
    {
      category: "asset",
      key: "key4",
      title: "台車は借りられるの？",
      content:
        '<div>トランクタイプ（屋内型）には台車をご用意しております。<br>ご自由にお使いください。<br><span class="fc04">※</span>物件によって異なる場合がございます。</div>',
    },
    {
      category: "asset",
      key: "key5",
      title: "管理人はいますか？",
      content:
        "<div>常駐の管理人はおりませんが、定期的に専門スタッフが巡回・清掃をしております。<br>安心してご利用ください。</div>",
    },
    {
      category: "asset",
      key: "key6",
      title: "どれくらいの量が入りますか？",
      content:
        "<div>以下が目安でございますのでご参照ください。<br>2tトラック1台＝4帖サイズ<br>4tトラック1台＝8帖サイズ<br>1坪＝2帖<br>2坪＝4帖<br>1帖＝ミカン箱サイズ段ボール約70箱</div>",
    },
    {
      category: "asset",
      key: "key7",
      title: "重量制限はどのくらいですか？",
      content:
        "<div>最大積載量は、1㎡あたり500kgほどまで可能で、8帖タイプですと、全体で約7トンまでの耐荷重の仕様となっております。<br>ただし、1点にかかる重さではないため、重たいものを収納される際にはお気を付けください。</div>",
    },
    {
      category: "asset",
      key: "key8",
      title: "トランクルーム内の温度はどのくらいですか？",
      content:
        "<div>以下が目安でございますのでご参照ください。<br>コンテナタイプ（屋外型）<br>天井部分などには「断熱材」を使用しており、外気温＋3度前後ほどとなっております。<br>トランクタイプ（屋内型）<br>常温となっており、外気との差はほとんどございません。一部、空調のある物件もございます。</div>",
    },
    {
      category: "asset",
      key: "key9",
      title: "補償範囲ってどれくらいなの？",
      content:
        '<div>保険会社の規定に基づき、コンテナタイプ（屋外型）、トランクタイプ（屋内型）共に最大50万円の範囲で対応させて頂きます。詳しくは<a onclick="return toInner(event, this)" href="/agreement/">約款</a>をご確認ください。</div>',
    },
    {
      category: "asset",
      key: "key10",
      title: "部屋の中で軽作業はできるの？",
      content:
        "<div>荷物の出し入れに伴う作業以外はご遠慮頂いております。</div>",
    },
    {
      category: "contract",
      key: "key12",
      title: "実際に部屋を見学することはできますか？",
      content:
        "<div>お電話でのご予約を承ったのち、見学が可能です。お気軽にお問合せください。</div>",
    },
    {
      category: "contract",
      key: "key13",
      title: "契約時に必要なものは？",
      content:
        '<div>ご契約名義によって異なります。<br>詳細は「<a onclick="return toInner(event, this)" href="/flow#f1_2">ご契約について-ご契約に必要なもの</a>」をご確認ください。</div>',
    },
    {
      category: "contract",
      key: "key14",
      title: "即日の契約は可能？",
      content:
        "<div>①月々支払い方法:クレジットカード決済の場合<br>最短2日後からご利用可能でございます。<br>②月々支払方法:銀行口座引落しの場合<br>通常は郵送での契約になり、お申込みからご利用開始まで1週間ほどかかります。</div>",
    },
    {
      category: "contract",
      key: "key15",
      title: "初期費用はどの位かかるの？",
      content:
        '<div>おおよそ目安としてご使用料金の3.5ヶ月分ほどが必要となります。<br>詳細は「<a onclick="return toInner(event, this)" href="/flow#f1_1_1">ご契約について-初期費用について</a>」をご確認ください。</div>',
    },
    {
      category: "contract",
      key: "key16",
      title: "初期費用の支払方法は？",
      content:
        "<div>ご契約方法によって異なりますが、クレジットカード決済またはコンビニエンスストア及び銀行で使用できる払込用紙を送付いたします。</div>",
    },
    {
      category: "contract",
      key: "key17",
      title: "キャンペーン条件期間内に解約した場合はどうなりますか？",
      content:
        "<div>キャンペーン条件により異なりますが、違約金が発生する場合がございます。<br>詳しくはお電話にてお問合せください。</div>",
    },
    {
      category: "contract",
      key: "key18",
      title: "毎月の支払い方法は？",
      content:
        "<div>ご契約者様の本人名義の口座振替（毎月27日引落）、またはクレジットカード決済（毎月15日決済）でのお支払いとなります。</div>",
    },
    {
      category: "contract",
      key: "key19",
      title: "短期利用は可能？",
      content:
        "<div>おおよそ申込み月+翌月の2ヶ月間が最短でのご利用期間になります。<br>詳しくはお電話にてお問合せください。</div>",
    },
    {
      category: "contract",
      key: "key20",
      title: "一括支払いは可能？",
      content:
        "<div>申し訳ございませんがお支払方法は毎月の口座振替か、クレジットカード決済のどちらかのみ承っております。</div>",
    },
    {
      category: "contract",
      key: "key21",
      title: "未成年だが契約は可能？",
      content:
        "<div>ご結婚をされている有職者の方であれば可能でございます。<br>ご結婚をされていない場合は、親権者の方に連帯保証人になっていただくことでお受け付け可能でございます。</div>",
    },
    {
      category: "contract",
      key: "key22",
      title: "学生だが契約は可能？",
      content:
        "<div>アルバイトをしていらっしゃる成人の方であれば可能でございます。</div>",
    },
    {
      category: "contract",
      key: "key23",
      title: "外国籍なのだが契約は可能？",
      content:
        "<div>ご契約者様と緊急連絡先方の両名が日本語での会話ができること、また読み書きが可能であり、毎月のお支払方法をクレジットカード決済にしていただければ可能でございます。<br>詳しくはお電話にてお問合せくださいませ。</div>",
    },
    {
      category: "contract",
      key: "key24",
      title: "保証金は戻ってくるの？",
      content:
        '<div>解約後最長90日以内にご返金となります。ただし、解約後未精算金がある場合やお客様の過失によって室内に破損があったり、著しい汚れがある場合は保証金によって補填させていただくことがございます。<br>詳しくは<a href="/agreement/">約款</a>をご確認ください。</div>',
    },
    {
      category: "contract",
      key: "key25",
      title: "スペアキーは作れますか？",
      content:
        "<div>可能です。作成代金を頂戴しますので、詳細はお電話にてお問い合わせください。<br>お問い合わせ先：0120-86-3085（営業時間：9：00～18：00）</div>",
    },
    {
      category: "contract",
      key: "key26",
      title: "安心保証パックってなに？",
      content:
        '<div>万が一鍵をなくされてしまった場合の作成負担やご解約時に発生する8,640円（税込）の室内整備料が無料になるサービスでございます。<br>詳しくは「<a href="/anshinpack/">ハロー安心保証パック</a>」をご確認ください。</div>',
    },
    {
      category: "contract",
      key: "key27",
      title:
        "室内整備料/安心保証パックで原状回復費用は完全に請求されないのか。",
      content:
        "<div>軽度な修繕状態であれば別途ご請求は発生致しません。ただし、大きな穴があいてしまったり、大きなシミなどがついてしまった場合など、明らかに大きな損害が見受けられる際はご連絡させていただく場合がございます。</div>",
    },
    {
      category: "contract",
      key: "key28",
      title:
        "スマートキーってなんですか？",
      content:
        '<div>スマートフォン(アプリ)で物件の鍵を開けられるサービスです。<br>詳しくは、<a href="/app/">こちら</a>をご覧ください。</div>',
    },
    {
      category: "member",
      key: "key29",
      title: "鍵を紛失してしまった場合は？",
      content:
        '<div>鍵一つにつき、作成代金10,800円（税込）を頂戴します。<br>万が一紛失された際は速やかにご連絡ください。ご入金確認後、1週間～10日間で新しい鍵をお届けいたします。<br><span class="fc04">※</span>緊急対応が必要な場合、別途16,200円（税込）の費用が掛かります。</div>',
    },
    {
      category: "member",
      key: "key30",
      title:
        "緊急出動してほしい場合は料金がかかりますか？（トランクタイプ（屋内型））",
      content:
        "<div>セキュリティーカードを室内にお忘れのまま退館した場合は、現場担当の警備会社にて対応となりますので、緊急出動費用として3,240円（税込）かかります。</div>",
    },
    {
      category: "member",
      key: "key31",
      title: "住所変更した場合はどう手続きすればいいの？",
      content: "<div>お電話で変更できますのでご連絡ください。</div>",
    },
    {
      category: "member",
      key: "key32",
      title: "支払い方法の変更はどうすればいいの？",
      content: "<div>お電話で変更できますのでご連絡ください。</div>",
    },
    {
      category: "member",
      key: "key33",
      title: "解約はどうすればよいか？",
      content:
        '<div>ご連絡いただきました月の翌月末日でのご解約とさせていただきます。なお、日割りでのご解約は承っておりません。ご了承ください。詳しくは<a onclick="return toInner(event, this)" href="/agreement/">約款</a>をご確認ください。<br />Webからの解約お申込みは<a href="/mypage3/?action=cancel" target="_blank">Web解約ページ</a>からお申し込みください</div>',
    },
    {
      category: "member",
      key: "key34",
      title: "契約者名義を変更したいが可能？",
      content:
        "<div>お電話にてご希望をお伺いし、ご案内いたします。お気軽にお問合せください。</div>",
    },
    {
      category: "member",
      key: "key35",
      title: "契約者が亡くなってしまった場合はどうしたらいいの？",
      content:
        "<div>まずは関係者の方からご連絡くださいませ。その際に必要なお手続きをご案内いたします。</div>",
    },
    {
      category: "member",
      key: "key36",
      title: "部屋のサイズを変更することはできますか？",
      content: "<div>お電話で変更できますのでご連絡ください。</div>",
    },
    {
      category: "etc",
      key: "key37",
      title: "ハローストレージって？",
      content:
        "<div>24時間いつでもご利用できるレンタル収納スペースです。<br>屋内型・屋外型はもとより、バイク専用の物件など各種ラインナップを取り揃えております。<br>各種用途に合わせて物件をお選びください。<br>使い方もお客様次第です！<br>全国最大級の管理室数を誇る「ハローストレージ」ブランドなら、ご希望に沿った物件がみつかります。</div>",
    },
    {
      category: "etc",
      key: "key38",
      title: "トランクルームに収納するときのアドバイスはありますか？",
      content:
        "<div>1. 衣類（着物）はクリーニングした後に、衣装ケース等に入れ、乾燥剤・防虫剤を入れて収納することをお勧めします。<br>2. アウトドア用品は、よく乾かしてから収納することをお勧めします。<br>3. 革製品はこまめなお手入れが必要です。お客様個々での管理をお願いします。<br>4. 荷物はスノコを活用するなどし、隙間を空けて収納することをお勧めします。</div>",
    },
    {
      category: "etc",
      key: "key39",
      title: "海外から電話したい場合どうすればいいですか？",
      content:
        "<div>海外からご連絡の場合は<br>+81-3-6629-0067までご連絡ください</div>",
    },
  ];
}



// WEBPACK FOOTER //
// ./lib/faqData.js